<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findNode"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :disabled="disabled"
            :readonly="readonly"
            :multiple="multiple"
            :selected-multiple="nodeDetail"
            :prop="prop"
            key-id="_id"
            :key-label="keyLabel"
            :key-sub-label="keySubLabel"
            :param-prepare="paramPrepare"
            @change="handleChange">
            <template #default="{ item }">
                <p
                    class="align-middle"
                    :class="{ 'font-bold': keySubLabel }">
                    {{ item[keyLabel] || $t('labels.invalidData') }}
                </p>
                <p
                    v-if="keySubLabel"
                    class="align-middle font-light">
                    {{ item[keySubLabel] || '' }}
                </p>
            </template>
        </hts-form-select>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  nodeDetail: { type: Array, default: () => [] },
  prop: { type: String },
  type: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  nodeTypeId: { type: Boolean, default: false },
  name: { type: String, default: '' },
  label: { type: String, default: () => $t('labels.node') },
  businesses: { type: Object, default: () => {} },
  keyLabel: {
    type: String,
    default: 'name'
  },
  keyId: {
    type: String,
    default: '_id'
  },
  locationType: {
    type: String,
    default: ''
  },
  keySubLabel: {
    type: String,
    default: ''
  },
  paramPrepare: {
    type: String,
    default: ''
  },
  items: {
    type: Array
  }
})
const { $searchObjects } = useNuxtApp()

const { modelValue, type, name, nodeDetail, nodeTypeId, businesses, locationType, keySubLabel, items } = toRefs(props)

const information = ref([])
const emits = defineEmits(['update:modelValue', 'update:name', 'update', 'change'])

const cText = computed({
  get () {
    return name.value
  },
  set (val: any) {
    emits('update:name', val)
  }
})

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const findNode = async (s: string) => {
  const api = !nodeTypeId.value ? $urlAdmin.node.findNodes : $urlAdmin.node.findNodeByType
  const body = nodeTypeId.value
    ? { key: s, nodeType: type.value, typeId: nodeTypeId.value, businesses: businesses.value, locationType: locationType.value }
    : undefined
  const res = await $api(api, { uriParams: { KEY: s, NODETYPE: type.value, TYPEID: nodeTypeId.value }, body })

  const dataItems = items?.value ? $searchObjects(items.value, 'name', s, { i: true }) : []

  const resData: any = res?.data.value
  if (resData?.success) {
    return [...dataItems, ...resData.data]
  }
  return dataItems
}
const handleChange = (val: any) => {
  emits('change', val)
}
</script>
